// Main PDP Section
$slickGreen = false;
function greenSlider() {
  if ($(window).width() <= 767) {
      $('.pdp-left-image-row').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplaySpeed: 2000
      });
      $slickGreen = true;
  } else {
      if ($slickGreen) {
          $('.pdp-left-image-row').slick('unslick');
          $slickGreen = false;
      }
  }
}
$(document).ready(function () {
  greenSlider();
});
$(window).on('resize scroll', function () {
  greenSlider();
});

// $('.swatch-element').click(function() {
//   $(".swatch-element").find("label").css("border", "");
//   $(this).find("label").css("border", "1px solid #847f7f");
//   $('.check-stock-msg ').removeClass('active');
//   if($(".swatch").hasClass("selectsize")){
//     $(this).parent().addClass("selected");
//     $('.swatch').removeClass('selectsize');
//     $('.swatch').removeClass('selectsize');
//      if($("#PreOrder").prop('checked') == true){
//        $('.add-to-cart .add-to-cart-wishlist').addClass('pre-order-content');
//      }
//     $("#add").val($("#onClickContent").html());
//     $("#pleaseselectsize").css("display", "none");
//   }
// if($(this).hasClass("soldout")){
//   var bis_hidden = $('.button_recomndation').attr('data-bis-tag');
//   if(bis_hidden){
//     $('.button_recomndation').show();
//   }else{
//     $('.button_recomndation, .product_recommendations').hide();
//     $(".product-page-left-sec").removeClass("recm-view");
//   }
// }else{
//   $('.button_recomndation, .product_recommendations').hide();
//   $(".product-page-left-sec").removeClass("recm-view");
// }
// });

if($(window).width() > 767 && $(".product-page--main-content").length > 0){   
    if($(".product-page--main-content .product-page--images-container .main-litght-img:eq(0) video").length > 0){
      $(".product-page--main-content .product-page--images-container .main-litght-img:eq(0) video").get(0).play();
    }
    // var current_img_height = $(".product-page--main-content .product-page--images-container .main-litght-img a img").height();
    var element = document.querySelector(".main-litght-img").children[0].children[0];
    var px_height = window.getComputedStyle(element).height;
    var current_img_height = parseFloat(px_height.replace("px",''));
    $(".product-page--main-content .product-page--images").css('height', (current_img_height - 1)+'px');
  }
  
var $progressBar = $('.main-product-progress');
var slideCount = $(".product-page--main-content .main-litght-img").length;
var firstCalc = 100  / slideCount;
$progressBar.css('background-size', '100%' + firstCalc + '%').attr('aria-valuenow', firstCalc );

$(document).on("click",".main-thumbnail-slider .main-thumbnail-item",function(event){
  var gallery = this.closest('.product-page--images');
  var container = gallery && gallery.querySelector('.product-page--images-container');
  var thumbnailIndex = gallery && Array.prototype.indexOf.call(gallery.querySelectorAll('.main-thumbnail-slider .main-thumbnail-item'), this);
  var panel = container && container.querySelectorAll('.main-litght-img')[thumbnailIndex];
  if (!container || !panel || !container.contains(panel)) return;
  event.preventDefault();
  var targetTop = panel.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
  $(container).stop(true).animate({ 'scrollTop': targetTop }, 400);
});

// video paly& puse js start here
if($(".product-sec-holder").hasClass("product-video-first")){
  $("#desk-video, #mob-video").addClass("hide")
}else{
  if ($(".product-page-mobile--images-container .main-litght-img-mobile").hasClass("main_html_mp4_video")){
    $("#desk-video, #mob-video").removeClass("hide")
  }
}

$("#desk-video .video-btn, #mob-video .video-btn").click(function(){
    $('[data-href="thumbnail-item-0"]').trigger('click');
    $('.playbutton').trigger('click');
    $('video#prod_video').trigger('play');
});

function videobtn() {
    var thumbnailScroll = $('.main-thumbnail-scroll').width();
    $('#desk-video').css("left", (30 + thumbnailScroll))
 }
videobtn();
$(window).on('resize orientationchange', function () {
  videobtn();
});

$(window).scroll(function () {    
  var scroll = $(window).scrollTop();
  if (scroll >= 25) {
      $("#desk-video.video-btn-wp").addClass("head-sticky");
  } else {
      $("#desk-video.video-btn-wp").removeClass("head-sticky");
  }
  var targetscroll = $(".header-style-one").height();
  if (scroll >= targetscroll ) {
      $("#mob-video.video-btn-wp").addClass("head-sticky");
  } else {
      $("#mob-video.video-btn-wp").removeClass("head-sticky");
  }
});
$(window).on('resize orientationchange', function () {
  if($(window).width() > 767 && $(".product-page--main-content").length > 0){
    // var current_img_height = $(".product-page--main-content .product-page--images-container .main-litght-img a img").height();
    var element = document.querySelector(".main-litght-img").children[0].children[0];
    var px_height = window.getComputedStyle(element).height;
    var current_img_height = parseFloat(px_height.replace("px",''));
    $(".product-page--main-content .product-page--images").css('height', (current_img_height - 1)+'px');
  }
});

$(".product-page--main-content .product-page--images-container").scroll(function(){
    var current_val = $(".product-page--main-content .product-page--images-container").scrollTop() + $(".main-wrapper").offset().top;
    var singel_slide_height = $(".product-page--images-container .main-litght-img:eq(0)").height();
    var flag = true;
    var slideCount = $(".product-page--main-content .main-litght-img").length;
    var $progressBar = $('.main-product-progress');
    
    $(".product-page--images-container .main-litght-img").each(function( index ) {
        if($(this).offset().top - $(".header-key-message").innerHeight() <= $(".main-wrapper").offset().top + 29 && $(this).offset().top - $(".header-key-message").innerHeight() + singel_slide_height >= $(".main-wrapper").offset().top + 29 && flag == true){
            $(this).addClass("is-active");
            var current_active = $(this).attr("id");
            if (!this.closest('.mdv-gallery-4up')) {
              $('.main-thumbnail-slider .main-thumbnail-item').removeClass("is-active");
              $('.main-thumbnail-slider .main-thumbnail-item[data-href="'+current_active+'"]').addClass("is-active");
            }
            if($(this).find('.main_html_mp4_video video').length > 0){
            $(this).find('.main_html_mp4_video video').trigger('play');
              setTimeout(function(){
                  if($('[data-href="thumbnail-item-0"]').hasClass('is-active')) {
                    $("#desk-video").addClass("hide")
                  }else if($(".product-sec-holder").hasClass("product-video-first")) {
                     $("#desk-video").addClass("hide")
                  }else{
                    $("#desk-video").removeClass("hide")
                  }
              },50);
            }else{
              $(".product-page--images-container .main-litght-img .main_html_mp4_video video").trigger('pause');
              if($(this).find('.main_html_mp4_video video').length > 0){
              }
            }
          
            var current_index = $(this).index() + 1;
            var calc = ( (current_index) / (slideCount) ) * 100;
            $progressBar.css('background-size', '100%' + calc + '%').attr('aria-valuenow', calc );
          
            flag = false;
        }else{
            $(this).removeClass("is-active");
        }
    });
});




function updateDeliveryContentWithAjax() {

  $.ajax({
    url: '/?section_id=update-delivery-content',
    type: 'GET',
    dataType: 'html',
    success: function (data) {

      var scriptText = $(data).find('script:contains("countryDelivery")').html();
      if (!scriptText) return;

      var match = scriptText.match(/const countryDelivery\s*=\s*(\[[\s\S]*?\]);/);
      if (!match) return;

      var countryDelivery = eval(match[1]);

      // Change this to any country code you want
      var selectedCountry = (window.mdvSelectedCountryForThisStore
        && window.mdvSelectedCountryForThisStore()) || Shopify.country ;

      var countryData = countryDelivery.find(function(item) {
        return item.countryCodes.includes(selectedCountry);
      });

      if (!countryData) {
        countryData = countryDelivery.find(function(item) {
          return item.countryCodes.includes('REST OF WORD');
        });
      }

      // Clear existing content
      $('.update-delivery-content').html('');

      if (countryData) {
        $.each(countryData.countryText, function(i, html) {
          $('.update-delivery-content').append(html);
        });
      } 
    }
  });

}

$(document).ready(function () {
  updateDeliveryContentWithAjax();
});